import { render, staticRenderFns } from "./valuationList.vue?vue&type=template&id=755377c0&scoped=true"
import script from "./valuationList.vue?vue&type=script&lang=js"
export * from "./valuationList.vue?vue&type=script&lang=js"
import style0 from "./valuationList.vue?vue&type=style&index=0&id=755377c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755377c0",
  null
  
)

export default component.exports